import styled from "styled-components";
import Check from "assets/images/health-analyse/check.svg";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      height: calc(-100px + 100vh);
    }
  }

  .btn-dark {
    background-color: #142c1f;
    color: white;
    border-radius: 8px;
    padding: 12px;
    border: none;
    font-weight: 600;
    cursor: pointer;
  }

  .w-full {
    width: 100%;
  }

  .mt-8 {
    margin-top: 32px;
  }
`;

export const ContentSection = styled.div`
  padding: 20px 16px 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InsuranceSection = styled.div`
  width: 100%;
  margin-bottom: 24px;

  .check-text {
    font-size: 16px;
    color: #44554c;
    margin-bottom: 8px;
  }

  .insurance-label {
    margin-bottom: 24px;
    font-size: 16px;
    color: #142c1f;
  }

  .reimbursement-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;

    span {
      font-size: 16px;
      color: #44554c;
    }

    .amount {
      font-size: 20px;
      font-weight: 600;
      color: #1c9d87;
    }
  }
`;

export const SelectBox = styled.div`
  border: 2px solid #e2e4e9;
  border-radius: 10px;
  padding: 14px 16px;
  background-color: white;
  cursor: pointer;

  .placeholder {
    color: #808080;
    font-size: 16px;
  }
`;

export const PlanOptions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PlanCard = styled.div`
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? "#f9f9f9" : "white")};
  border: 3px solid ${(props) => (props.selected ? "#2ECF9699" : "#E0E0E0")};
  box-shadow: 0px 13px 20px #d6d6d629;
  border-radius: 15px;
  color: ${(props) => (props.selected ? "#2ECF96" : "#142C1F")};
  ${(props) =>
    props.highlight &&
    `
    border: 2px solid ${props.selected ? "#2ecf96" : "#142C1F"};
  `}

  .plan-title {
    font-size: 18px;
    margin-bottom: 4px;
    color: #142c1f;
  }

  .plan-price {
    font-size: 16px;
    margin-bottom: 4px;
    color: inherit;
    margin-top: 8px;
    margin-bottom: 4px;
  }

  .plan-duration {
    font-size: 16px !important;
    color: #71807a;
    margin-bottom: 16px;
  }

  .plan-features {
    display: flex;
    flex-direction: column;
    gap: 12px;
    span {
      color: #44554c;
      font-size: 16px;
    }
    strong {
      font-weight: bold;
      font-size: 16px;
    }
    .feature {
      display: flex;
      align-items: center;
      gap: 15px;

      .check {
        color: #4caf86;
        font-weight: bold;
      }
      p {
        color: #44554c;
        strong {
          font-weight: 600;
        }
      }
    }
  }
`;

export const PartnersSection = styled.div`
  width: 100%;
  text-align: center;

  .partner-row {
    display: flex;
    justify-content: space-around;
    margin-bottom: 16px;

    .partner-logo {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      color: #aaa;
      font-size: 12px;
    }
  }

  .certificate-link {
    color: #4caf86;
    font-size: 16px;
    margin-top: 16px;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Title = styled.h3`
  color: #142c1f;
  margin: 12px auto;
  font-size: 16px;
  text-align: center;
  @media screen and (max-width: 768px) {
    width: 280px;
    line-height: 24px;
  }
`;
export const Divider = styled.div`
  width: "100%";
  height: 1px;
  background: #e2e4e9;
  margin: 10px 0px;
  margin-left: -16px;
  margin-right: -16px;
  @media screen and (min-width: 768px) {
    margin-left: -25px;
    margin-right: -25px;
  }
`;

// Add responsive view containers
export const MobileContent = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const DesktopContent = styled.div`
  display: none;
  padding: 30px;

  @media (min-width: 769px) {
    display: block;
  }
`;

// Desktop styles that match the image
export const DesktopHeader = styled.div``;

export const DesktopTitle = styled.h2`
  font-size: 20px;
  color: #142c1f;
  margin: 0 0 10px;
`;

export const DesktopSubtitle = styled.p`
  color: #44554c;
  margin: 0;
`;

export const DesktopInsuranceSection = styled.div`
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 10px;
`;

export const InsuranceLabel = styled.h3`
  display: block;
  font-size: 14px;
  color: #142c1f;
  margin-bottom: 10px;
`;

export const InsuranceSelectWrapper = styled.div`
  margin-bottom: 10px;
`;

export const InsuranceInput = styled.input`
  width: 100%;
  padding: 12px 15px;
  border: 1.5px solid #e2e4e9;
  border-radius: 10px;
  font-size: 16px;
  color: #2c2c2c;

  &::placeholder {
    color: #808080;
  }

  &:focus {
    outline: none;
    border-color: #2ecf96;
  }
`;

export const ReimbursementLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReimbursementText = styled.p`
  color: #44554c;
`;

export const ReimbursementAmount = styled.h3`
  font-size: 20px;
  color: #1c9d87;
`;

export const DesktopFeeLabel = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #142c1f;
  margin: 0 0 30px;
`;

export const DesktopPlansWrapper = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 20px;
`;

export const DesktopPlanCard = styled.div`
  position: relative;
  border: 2px solid ${(props) => (props.active ? "#2ECF96" : "#e2e4e9")};
  border-radius: 10px;
  padding: 25px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  }
`;

export const PlanHeader = styled.div`
  margin-bottom: 20px;
`;

export const PlanName = styled.h3`
  font-size: 20px;
  color: #142c1f;
  margin: 0 0 10px;
`;

export const PlanPricing = styled.div`
  margin-bottom: 20px;
`;

export const PlanPrice = styled.h3`
  font-size: 16px;
  color: ${(props) => (props.active ? "#2ecf96" : "#142C1F")};
`;

export const PlanDuration = styled.p`
  color: #142c1fcc;
  margin-top: 5px;
`;

export const PlanFeatures = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
export const PlanFeaturesSecondCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const Feature = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const FeatureCheck = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  background-image: url(${Check});
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 2px;
`;

export const FeatureText = styled.p`
  line-height: 1.4;
  color: #44554c;
  strong {
    font-weight: 600;
  }
`;
